var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.temAgente
    ? _c("ComposerInlineSelect", {
        ref: "select",
        staticClass: "agent-select",
        class: [_vm.classeChip, { "agent-select--so-icone": _vm.soIcone }],
        attrs: {
          "abrir-por-fora": _vm.abrirPorFora,
          align: _vm.align,
          direction: _vm.direction,
          "active-color": "var(--primary)",
          "icon-color": "var(--neutral-700)",
          label: _vm.rotuloChip,
          icon: _vm.iconeChip,
          "so-icone": _vm.soIcone,
          tooltip: _vm.tooltipDoChip,
          options: _vm.opcoes,
          "panel-width": _vm.larguraPainel,
          disabled: _vm.menuBloqueado
        },
        on: {
          "abrir-externo": function($event) {
            return _vm.$emit("abrir-externo")
          }
        }
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }